"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var useLegacyAnnotationDeprecation = function useLegacyAnnotationDeprecation(annotationsEnabled, annotationTypes, environment) {
  (0, _react.useEffect)(function () {
    if (annotationsEnabled && !annotationTypes && !environment.includes('prod')) {
      console.warn('Annotation usage without the annotation toolbar layout has been deprecated and will be removed in a future release. Please migrate by using the annotationTypes prop.');
    }
  }, [annotationsEnabled, annotationTypes, environment]);
};

var _default = useLegacyAnnotationDeprecation;
exports.default = _default;